import ParentCountBadge from "./ParentCountBadge";

export default ParentCountBadge;
